<template>
  <span :id="$attrs['id']" :class="[ styleClass() ]">
    <svgicon :icon="icon" :original="true"/>
  </span>
</template>

<script>

import { startsWith } from 'lodash';

export default {
  name: 'Icon',

  props: {
    icon: {
      required: true,
    },
    color: {
      required: false,
      default: '#000',
    },
  },

  data() {
    return {
    };
  },

  computed: {
    fill: function () {
      return startsWith(this.icon, 'fill');
    },
  },

  methods: {
    styleClass: function () {
      return `hm-icon ${(startsWith(this.icon, 'fill') ? 'icon--filled' : 'icon--line')} ${this.icon}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .hm-icon {
    display: grid;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/Icon.vue